/**
 * Display transform for the backend's RMS waveform peaks.
 *
 * Soft compression: `1 - e^(-p·K)` rises steeply for quiet values and
 * approaches 1 asymptotically, so loud sections keep visible variation
 * instead of clipping flat ("sausage") the way a fixed multiplier does on
 * loud or low-dynamic-range tracks (constant-loudness chants were solid
 * bars under `barHeight: 5`). The curve is monotonic, so cross-track
 * loudness differences survive: a quiet track still renders shorter than a
 * loud one. Same curve + K as the catalog's canvas fallback renderer —
 * every waveform surface (catalog rows, bottom player, /song) shares it.
 */
export const WAVEFORM_COMPRESSION_K = 2.7;

/** Post-compression amplitude. The curve tops out ~0.66 for the loudest real
 * RMS values (~0.4), which reads too small in a 32px lane — 1.5 brings loud
 * sections to ~85–100% while quiet passages stay clearly shorter. Values only
 * touch the ceiling above RMS ≈ 0.45, which no track in the catalog reaches
 * sustained. */
export const WAVEFORM_GAIN = 1.5;

export const compressPeaks = (peaks: number[]): number[] =>
  peaks.map((p) => Math.min(1, (1 - Math.exp(-Math.abs(p) * WAVEFORM_COMPRESSION_K)) * WAVEFORM_GAIN));
